export const cardStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '12px 16px',
  borderRadius: '8px',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  backgroundColor: ({ palette }) => palette.background.paper,
  cursor: 'pointer',
  transition: 'box-shadow 0.2s ease, border-color 0.2s ease',

  '&:hover': {
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    borderColor: ({ palette }) => palette.border.input,
  },
};

export const cardTopRowStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: '8px',
};

export const fieldNameStyles = {
  color: 'text.primary',
  flex: 1,
  wordBreak: 'break-word',
};

const changeTypeBadgeStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  padding: '2px 8px',
  borderRadius: '4px',
  whiteSpace: 'nowrap',
};

export const valueDiffStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
};

export const cardBottomRowStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '8px',
};

export const authorInfoStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
};

export const authorNameStyles = {
  color: 'text.secondary',
};

export const timestampStyles = {
  color: 'text.secondary',
  whiteSpace: 'nowrap',
};

export const arrowStyles = {
  margin: '0 4px',
  color: 'text.secondary',
};

export const valueDiffRowStyles = {
  display: 'flex',
  alignItems: 'baseline',
  flexWrap: 'wrap',
};

export const getChangeTypeBadgeDynamicStyles = badgeConfig => ({
  ...changeTypeBadgeStyles,
  color: badgeConfig.color,
  backgroundColor: badgeConfig.backgroundColor,
});
